//- instagramMedia
if ($('#howToUse').length) {  
    doWhenInViewport($('#howToUse').prev().prev().prev()[0], function(entries, observer) {
        if (entries[0].isIntersecting && !$('.instagramMedia__posts').hasClass('slick-initialized')) {
            $.ajax({
                url: '//www.instagram.com/embed.js',
                type: 'GET',
                dataType: "script",
                crossDomain: true,
                headers: { 'Access-Control-Allow-Methods': 'GET, POST, PUT' }
              })
            const posts = window.instagramPosts;
                
            $('.instagramMedia__posts').promise().done(function() {
                $('.instagramMedia__posts:not(.slick-initialized)').slick({
                    infinite: false,
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    speed: 700,
                    adaptiveHeight: true,
                    centerMode: true,
                    centerPadding: '30px'
                });

                $('.instagramMedia__post-toggle').on('click', function(e){
                    $(this).parent().removeClass('instagramMedia__post--collapse');
                    $(this).closest('.slick-list').addClass('expand');
                });
            
                $('.instagramMedia__posts').on('beforeChange', function(event, slick, direction){
                    $('.instagramMedia__post').addClass('instagramMedia__post--collapse');
                    $('html, body').animate({
                        scrollTop: $("#howToUse").offset().top - 30
                    }, 1000);
                });
            });
        }
    });
}

